import React from 'react';
import { Add, InfoOutlined, ModeEditOutlineTwoTone } from "@mui/icons-material";
import {  Button, IconButton } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { BaseTabs } from "components/Shared/BaseTabs";

import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import AppTableDateTime from "components/Shared/AppTableDateTime";

import { useAppMeta, useTablePagination } from "hooks";
import { useLazyListRouteShipmentsQuery } from "store/services/routeShipmentApi";

const RouteShipmentListScreen = () => {
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [{ title: "Route Shipments" }];

  const transhipmentTabs = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const columns = [
    {
      name: "Route Name",
      selector: (row) => row?.routeName,
      cell: (row) => row?.routeName,
    },
    {
      name: "Description",
      selector: (row) => row?.description,
      cell: (row) => row?.description,
    },
    {
      name: "Origin Branch",
      selector: (row) => row?.origin?.name,
      cell: (row) => row?.origin?.name,
    },
    {
      name: "Destination Branch",
      selector: (row) => row?.destination?.name,
      cell: (row) => row?.destination?.name,
    },
  
    
    {
      name: "Created At",
      selector: (row) => <AppTableDateTime date={row?.createdAt} />,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/route-shipment/${row?._id}/detail`}>
            <IconButton size="small" aria-label="View Route Shipment" color="primary">
              <InfoOutlined />
            </IconButton>
          </Link>
          <Link to={`/app/crm/route-shipment/${row?._id}/edit`}>
            <IconButton size="small" aria-label="Edit Route Shipment">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  // RTK Query
  const [fetchRouteShipments, { data: routeShipmentsRes, isLoading, isFetching, error }] = useLazyListRouteShipmentsQuery();

  React.useEffect(() => {
    fetchRouteShipments({
      active: activeTab === "Active",
      page: currentPage,
      limit: perPage,
      ...(keyword && { keyword })
    });
  }, [activeTab, currentPage, fetchRouteShipments, keyword, perPage]);

  useAppMeta(`${activeTab} Route Shipments`);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <BaseTabs tabs={transhipmentTabs} defaultValue={activeTab} />

        <TableFilter searchLabel="Route Name" disabled={isLoading || isFetching}>
          <div className="font-medium"> {activeTab} Route Shipments </div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={routeShipmentsRes?.data ?? []}
          progressPending={isLoading || isFetching}
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={routeShipmentsRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RouteShipmentListScreen;

const PageActions = () => {
  return (
    <>
      <Link to="/app/crm/route-shipment/create">
        <Button startIcon={<Add />} variant="contained" color="primary">
          Add Route Shipment
        </Button>
      </Link>
    </>
  );
};
